// extracted by mini-css-extract-plugin
export default {"highlightedNav":"AppLayout_highlightedNav__nTEiv","content":"AppLayout_content__BDQkL"};